// src/container.tsx
import * as React from "react";
import { jsx } from "react/jsx-runtime";
var Container = React.forwardRef(({ children, style, ...props }, forwardedRef) => {
  return /* @__PURE__ */ jsx(
    "table",
    {
      align: "center",
      width: "100%",
      ...props,
      ref: forwardedRef,
      "data-id": "__react-email-container",
      role: "presentation",
      cellSpacing: "0",
      cellPadding: "0",
      border: 0,
      style: { maxWidth: "37.5em", ...style },
      children: /* @__PURE__ */ jsx("tbody", { children: /* @__PURE__ */ jsx("tr", { style: { width: "100%" }, children: /* @__PURE__ */ jsx("td", { children }) }) })
    }
  );
});
Container.displayName = "Container";
export {
  Container
};
